/**
 * Created by AlexanderC on 2/22/17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrontendContext = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BackendContext2 = require('./BackendContext');

var _ClientSession = require('./Frontend/ClientSession');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let FrontendContext = exports.FrontendContext = function (_BackendContext) {
  _inherits(FrontendContext, _BackendContext);

  function FrontendContext() {
    _classCallCheck(this, FrontendContext);

    return _possibleConstructorReturn(this, (FrontendContext.__proto__ || Object.getPrototypeOf(FrontendContext)).apply(this, arguments));
  }

  _createClass(FrontendContext, null, [{
    key: 'fromKernel',

    /**
     * @param {Kernel|*} kernel
     *
     * @returns {AbstractContext|*}
     */
    value: function fromKernel(kernel) {
      return _get(FrontendContext.__proto__ || Object.getPrototypeOf(FrontendContext), 'fromKernel', this).call(this, kernel).addObj(FrontendContext.clientData).addObj(FrontendContext.envData);
    }

    /**
     * @returns {*}
     */

  }, {
    key: 'clientData',
    get: function get() {
      return {
        sessionId: _ClientSession.ClientSession.instance.getSessionId(),
        fingerprint: _ClientSession.ClientSession.instance.getFingerprint(),
        browser: _ClientSession.ClientSession.instance.getBrowser(),
        browserVersion: _ClientSession.ClientSession.instance.getBrowserVersion(),
        os: _ClientSession.ClientSession.instance.getOS(),
        osVersion: _ClientSession.ClientSession.instance.getOSVersion(),
        resolution: _ClientSession.ClientSession.instance.getCurrentResolution(),
        timezone: _ClientSession.ClientSession.instance.getTimeZone(),
        language: _ClientSession.ClientSession.instance.getLanguage()
      };
    }

    /**
     * @returns {*}
     */

  }, {
    key: 'envData',
    get: function get() {
      return {
        location: {
          hash: window.location.hash,
          host: window.location.host,
          href: window.location.href,
          origin: window.location.origin,
          pathname: window.location.pathname,
          port: window.location.port,
          protocol: window.location.protocol,
          search: window.location.search
        },
        propertyId: window.location.host, // @todo read from env?
        platform: _ClientSession.ClientSession.instance.getSitePlatform()
      };
    }
  }]);

  return FrontendContext;
}(_BackendContext2.BackendContext);


//////////////////
// WEBPACK FOOTER
// ../~/deep-event/lib.compiled/Context/FrontendContext.js
// module id = 382
// module chunks = 0